/* eslint-disable no-param-reassign */
import * as React from 'react';
import { setConfig } from '@leagueplatform/core';

export function useDynamicConfig() {
  React.useEffect(() => {
    setConfig((config) => {
      config.careDiscovery = {
        ...config.careDiscovery,
        masonryAppId: {
          left: 'getCarePageWebLeft$root',
          right: 'getCarePageWebRight$root',
        },
        masonryAppVersion: '2.0',
        getCareLandingMasonryQueryParams: {
          platform: 'web',
        },
      };

      return config;
    });
  }, []);
}
